import { render, staticRenderFns } from "./TeachingEffect.vue?vue&type=template&id=0dc79238&scoped=true&"
import script from "./TeachingEffect.vue?vue&type=script&lang=js&"
export * from "./TeachingEffect.vue?vue&type=script&lang=js&"
import style0 from "./TeachingEffect.vue?vue&type=style&index=0&id=0dc79238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc79238",
  null
  
)

export default component.exports